import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { BaseResourceService, Tombamento, Page } from 'eddydata-lib';

@Injectable({
  providedIn: 'root'
})
export class TombamentoService extends BaseResourceService<Tombamento> {

  constructor(
    protected injector: Injector
  ) {
    super(`tombamentos`, injector);
  }

  public obterPorPlaca(placa: number, orgaoId: number): Observable<Tombamento> {
    return this.http.get<Tombamento>(`${this.login.cidade.id}/${this.api}/obter?placa=${placa}&orgao_id=${orgaoId}`, this.httpOptions()).pipe(
      map(res => res),
      catchError(err => this.handleError(err))
    );
  }

  public proximaPlaca(orgaoId: number): Observable<number> {
    return this.http.get<number>(
      `${this.login.cidade.id}/${this.api}/proxima-placa?orgao=${orgaoId}`,
      this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

  public obterPorDataIncorporado(data1: string, data2: string, orgaoId: number): Observable<Array<Tombamento>> {
    return this.http.get<Array<Tombamento>>(`${this.login.cidade.id}/${this.api}/filtrar-incorporados/${data1}/${data2}/${orgaoId}`,
      this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

  public obterPorDataBaixado(data1: string, data2: string, orgaoId: number): Observable<Array<Tombamento>> {
    return this.http.get<Array<Tombamento>>(`${this.login.cidade.id}/${this.api}/filtrar-baixados/${data1}/${data2}/${orgaoId}`,
      this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }
}
